webpackJsonp([138389209811418],{

/***/ 1232:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"htmlAst":{"type":"root","children":[{"type":"element","tagName":"h2","properties":{},"children":[{"type":"text","value":"Uitleg"}]},{"type":"text","value":"\n"},{"type":"element","tagName":"p","properties":{},"children":[{"type":"text","value":"De vormen van het "},{"type":"element","tagName":"a","properties":{"href":"/spqr/rijtjes/betrekkelijk-voornaamwoord"},"children":[{"type":"text","value":"betrekkelijk voornaamwoord"}]},{"type":"text","value":" zijn onregelmatig en moet je dus uit je hoofd leren. Gelukkig zijn ze hetzelfde als de vormen van het "},{"type":"element","tagName":"a","properties":{"href":"/spqr/rijtjes/vragend-voornaamwoord"},"children":[{"type":"text","value":"bijvoeglijk vragend voornaamwoord"}]},{"type":"text","value":"."}]}],"data":{"quirksMode":false}},"frontmatter":{"book":"spqr","leerdoel":"24d","title":"Leerdoel 24d"}}},"pathContext":{"slug":"/spqr/leerdoelen/24d/","title":"Leerdoel 24d"}}

/***/ })

});


// WEBPACK FOOTER //
// path---spqr-leerdoelen-24-d-c9ae37ef758e6dcaa4b1.js